module.exports = __webpack_public_path__ + "static/media/logo-selcorp.b0f12286.png";